import axios from 'axios';
import { getLocalStorage } from 'hooks/useLocalStorage';

const url = process.env.REACT_APP_API_BASEURL;

const client = axios.create({
  baseURL: `${url}`,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Content-Language': 'ko',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  timeout: 20000
});

// client.defaults.headers.common['Authorization'] = 'AUTH_TOKEN' // request header 변경 필요 시 사용
// client.defaults.headers.get['Accept'] = 'application/json' // request header 변경 필요 시 사용

client.interceptors.request.use(
  (config) => {
    config.params = config.params || {};
    let user = getLocalStorage('persist:user');
    let menu = getLocalStorage('openMenuInfo');
    let userObj = user;

    if (user && user !== 'null') {
      if (typeof user !== 'object') userObj = JSON.parse(user);
      let firstMenuId = -1;
      switch (userObj.level_no) {
        case 1:
          firstMenuId = 2;
          break;
        case 2:
          firstMenuId = 61;
          break;
        case 3:
        case 4:
          firstMenuId = 97;
          break;
        case 5:
          firstMenuId = 2;
          break;
        case 6:
          firstMenuId = 2;
          break;
      }
      config.headers.Authorization = userObj.login_token;
      config.headers.user_idx = user.user_idx;
      config.headers.menu_idx = menu?.id ? menu?.id : firstMenuId;
      config.headers.level_no = user.level_no;
    }
    // config.params["api_key"] = "86243712afd0457f7ec4e7cc2ad4208b";
    // config.params["language"] = "en-US";
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

client.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    console.log('error', error);
    return Promise.reject(error);
  }
);

export default client;
